
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';

interface EmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  rememberEmail: boolean;
  onRememberChange: (checked: boolean) => void;
  showRememberOption?: boolean;
}

const EmailInput: React.FC<EmailInputProps> = ({
  email,
  setEmail,
  rememberEmail,
  onRememberChange,
  showRememberOption = true
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="email">Email</Label>
      <Input
        id="email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        placeholder="Enter your email"
      />
      {showRememberOption && (
        <div className="flex items-center space-x-2">
          <Checkbox
            id="rememberEmail"
            checked={rememberEmail}
            onCheckedChange={onRememberChange}
          />
          <Label htmlFor="rememberEmail" className="text-sm text-gray-600">
            Remember email
          </Label>
        </div>
      )}
    </div>
  );
};

export default EmailInput;
